// ########################################
// ########### GLOBAL FUNCTIONS ###########
// ########################################

function resizeHandler() {
  console.log("window resized");

  // FOOTER NAV RESPONSIVE FUNCTIONS:
  if ($(window).width() < 992) {
      //console.log("the window is smaller than 992px");
      $('.js_mobile-accordion--content').slideUp(200);
  } else{
      $('.js_mobile-accordion--content').show();
      $('.js_mobile-accordion--trigger').removeClass('expanded');
  }

  // MEGAMENU TOP POSITION 
  var headerHeight = $('#shopify-section-header').outerHeight();
  $('#shopify-section-header .mega-menu').css({'top' : headerHeight + 'px'});

  // DESKTOP SEARCH TOP POSITION
  $('#search-pop').css({'top' : headerHeight + 'px'});
}

function setFocusableState(element, focusable) {
  const focusableElements = element.find('a, button, input, textarea, select, details, [tabindex]');

  focusableElements.each(function() {
    if (focusable) {
      $(this).removeAttr('tabindex');
    } else {
      $(this).attr('tabindex', '-1');
    }
  });
}

// ########################################
// ########### DOC READY START ############
// ########################################
$(document).ready(function() { 
  // By default, don't make mobile-nav focusable
  const mobileMenu = $('.mobile-nav');
  setFocusableState(mobileMenu, false);

  // #### CALL RESIZE HANDLER ON LOAD ####
  resizeHandler();
  
  /* // hover click in pdp thoumbnails
  $('.product-thumbs .js-slider-thumbs .thumb-fit-wrap').each(function() {
    $(this).hover(function() {
      $(this).click();
    });
  }); */
  
  // #### BODY CLASS ON NAV OPEN ####
  $( ".js-nav-control" ).click(function() {
    const mobileMenu = $('.mobile-nav');

    $('body').toggleClass('open');

    if ($('body').hasClass('open')) {
      setFocusableState(mobileMenu, true);
      if ($('.mobile-search').length) {
        $('.mobile-search input').focus();
      } else {
        $('.mobile-menu.js_mobile-menu .parent li:first-child').focus();
      }
    } else {
      setFocusableState(mobileMenu, false);
      $('.hamburger.js-nav-control').focus();
    }

    var hamburgerAriaHidden = $('.hamburger.js-nav-control').attr('aria-hidden');
    $('.hamburger.js-nav-control').attr('aria-hidden', hamburgerAriaHidden === 'true' ? 'false' : 'true');
  });
  
  // #### MOBILE FOOTER SECTION TOGGLES ####
  $('.js_mobile-accordion--trigger').click(function () {
		var $clicked = $(this);
		$('.js_mobile-accordion--trigger').each(function(){
			if ($(this).hasClass('expanded') && $(this)[0] != $clicked[0] ) {
				$(this).next().slideToggle(200);
				$(this).toggleClass('expanded');
			}
		});

		$(this).next().slideToggle(200);
		$(this).toggleClass('expanded');

    return false;
	});
  

  
  // #### SEARCH ####
  $('.js_cart-wrap').on("click", function(e) {
    $('#search-pop').hide();
    $('body').removeClass('open');
  });
  $("body").on("click", '.js_desktop-search-trigger, .js_search-close', function(e) {
    $('body').toggleClass('open');
    $('#search-pop').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
  });
  

  
  // #### QUANTITY INCREMENTER ####
  $('.js-qty-wrap').each(function() { 
    var addInput = '.js-qty-wrap'; 
    var inputEl = $(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = $(this).closest(addInput).find('.plus');
    var minEl = $(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n);
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        inputEl.val(--n);
      } 
    });
  });

  
  // #### SLICK SLIDERS ####
  

  // HOME HERO CAROUSEL
  $('.js_hero-carousel').on('init', function(event, slick){
    //console.log("js_hero-carousel initialized");
    $(this).removeClass('slick-dotted');
    $('.js_hero-carousel .slick-dots').appendTo( $('.js_hero-carousel .js_hero-carousel-dots') );
    $('.js_hero-carousel-dots li:only-child').closest('.js_hero-carousel-dots').hide();
    $(this).find('.slick-current').removeClass('slick-active').addClass('reset-animation');
    setTimeout( function() {
      $('.js_hero-carousel').find('.slick-current').removeClass('reset-animation').addClass('slick-active');
    }, 1);
  });

  $('.js_hero-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots:true,
    fade: true,
    autoplay:true,
    autoplaySpeed: 15000,
    infinite:true,
  });

  // ITEM SLIDERS (COLLECTION, BLOG, RECIPES)
  $(".js_item-slider").each(function () {
    var slider = $(this);
  
    slider.slick({
      slidesToShow: 3,
      slidesToScroll:1,
      appendArrows: slider.next('.js_item-slider-arrows'),
      prevArrow: "<a href='#' class='previous-arrow' aria-label='Previous Slide'><svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 448 512'><path d='M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/></svg></a>",
      nextArrow: "<a href='#' class='next-arrow' aria-label='Next Slide'><svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 448 512'><path d='M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z'/></svg></a>",
      infinite:false,
      dots:false,
      responsive: [     
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            centerMode: true,
            centerPadding: '50px',
            slidesToShow: 1,
            arrows:false,
          }
        }
      ]
    });
  });
  
  
  // TESTIMONIALS SLIDER CODE IS IN sections/component-testimonials.liquid

  // PDP CAROUSEL WITH THUMBS
  $('.js-slider-primary').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots:false,
    fade: true,
    infinite:true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true,
          infinite: false,
        }
      }
    ]
  });

  $('.js-slider-thumbs').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.js-slider-primary',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite:false,
    variableWidth: false,
    arrows: false,
    prevArrow: "<a href='#' class='previous-arrow' aria-label='Previous Slide'><i class='carousel-arrow carousel-arrow-prev'></i></a>",
    nextArrow: "<a href='#' class='next-arrow' aria-label='Next Slide'><i class='carousel-arrow carousel-arrow-next'></i></a>",
    responsive: [
      {
        breakpoint: 992,
        settings: {
          infinite: false,
        }
      }
    ]
  });

  $(".slider_new-hero").each(function () {
    var slider = $(this);
    var speed = slider.attr('data-speed'); // Asume que 'data-speed' es el atributo que contiene la velocidad de reproducción automática

    slider.slick({
        slidesToShow: 1,
        slidesToScroll:1,
        arrows: true,
        prevArrow: "<a href='#' class='previous-arrow' aria-label='Previous Slide'><svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'><path d='M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z'/></svg></a>",
        nextArrow: "<a href='#' class='next-arrow' aria-label='Next Slide'><svg xmlns='http://www.w3.org/2000/svg' height='16' width='10' viewBox='0 0 320 512'><path d='M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z'/></svg></a>",
        dots:true,
        autoplay:true,
        autoplaySpeed: speed ? parseInt(speed) : 5000, // Si 'speed' existe, usa ese valor. De lo contrario, usa 5000 como valor predeterminado.
    });
});
  
  
  // #### PDP, COLLECTION PAGE -- CHANGE IMAGE & PRICE WITH VARIANT CHANGE ####
  $('.js_productSelect').change(function(event) {
    console.log('js_productSelect changed!!!!');
    // Update Price
    var selected     = this.options[this.selectedIndex],
    variantPrice = selected.getAttribute('data-variant-price');
    
    var compareAt = selected.getAttribute('data-variant-compare');
    var showCompare = $(this).parents('.js_product-form').find('.js_product-price, .js-product-compare')[1];
    var showPrice = $(this).parents('.js_product-form').find('.js_product-price, .js-product-price')[1];

    $(showPrice).html(variantPrice);

      if(compareAt){
        $(showCompare).html(compareAt);
      } else {
        $(showCompare).html('');
      }

    // Update Product Photos Slider 
    var variantImage = selected.getAttribute('data-image');
    
    var position = -1;

    $('.single-product-photo .single-photo').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });
    
    $('.product-thumbs .single-thumb').each(function() { 
      if ( $(this).data('image') == variantImage ) { 
        position = parseInt($(this).data('slick-index'));
        return;
      }
    });

    if ( position != -1 ) { 
      $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', position);
    }
    
  })
  
  
  // ****************************************
  // ********** WILD PLANET SCRIPTS *********
  // ****************************************
  

  // #### BLOG FILTERS ####

  
  /* not in use
  // #### PLYR VIDEOS - extends plyr.js ####
  $( '.videoplayer' ).each( function() {
      const player = new Plyr(this, {
          hideControls: true
      });
  });
  
  // Multiple videos on one page, pause one when playing another 
  $('.plyr').each( function(player) { 
    $(this).on('play',function(){ 
      $('.plyr--playing').not(this).trigger('click'); // clicking a playing player will pause it, so trigger that
    });
  });
  */  
  
  
  // #### IMAGE CAPTIONS ####
  $('.js_caption').click(function() {
    $(this).toggleClass('active');
  });

  

  
// ########### DOC READY END ############
}); 
// ########################################


// ########################################
// ############# WINDOW RESIZE ############
// ########################################
$(window).resize(resizeHandler);

// ########################################
// ############# ENTER PRESS TO CLICK######
// ########################################
function keyToClick(event) {
  if (event.key == "Enter") {
      event.preventDefault();
      event.target.click();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  function removeTnsControlsAriaLabel() {
    const tnsControls = document.querySelectorAll('.tns-outer .tns-controls');

    if (tnsControls) {
      tnsControls.forEach((control) => {
        control.removeAttribute('aria-label');
      });
    };
  }

  function addAltToAjaxLoader() {
    const ajaxLoader = document.querySelector('img#els-loader');

    if (ajaxLoader) {
      ajaxLoader.setAttribute('alt', '');
    };
  }

  removeTnsControlsAriaLabel();
  addAltToAjaxLoader();
});
/**
 * Truncates the paragraph text and adds a "Read More" button if the text exceeds a certain height.
 */
function truncateParagraph() {
  const text = document.querySelector(".collection-hero .hero-paragraph.truncated");
  const readMoreBtn = document.querySelector("#read-more-button");

  const fullHeight = text?.offsetHeight ?? 0;

  const mediaQueryList = window.matchMedia("(max-width: 767px)");
  
  function checkResolution(e) {
    if (e.matches) {
      // Si la resolución es menor o igual a 768px
      if (fullHeight > 2 * parseFloat(getComputedStyle(text).lineHeight ?? '1')) {
        readMoreBtn.style.display = "flex";
      } else {
        readMoreBtn.style.display = "none";
      }
    } else {
      // Si la resolución es mayor a 768px
      readMoreBtn.style.display = "none";
    }
  }

  // Comprueba la resolución inicial
  checkResolution(mediaQueryList);
  // Añade el listener para cambios de resolución
  mediaQueryList.addListener(checkResolution);

  readMoreBtn.addEventListener("click", function () {
    if (text) {
      if (text.classList.contains("truncated")) {
        text.classList.remove("truncated");
        readMoreBtn.innerText = "Read Less";
      } else {
        text.classList.add("truncated");
        readMoreBtn.innerText = "Read More";
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", truncateParagraph);
